export default __webpack_public_path__ + "0f93f60307.woff2";